import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { AuthState } from 'src/app/services/auth/auth.model';
import { ToastService } from 'src/app/services/toast/toast.service';

import { AuthService } from 'src/app/services/auth/auth.service';
import { skipWhile, take } from 'rxjs/operators';
import { RefereeContactsBLL } from '../referee-contacts.bll';
import { createMask } from '@ngneat/input-mask';

@Component({
  selector: 'app-referee-modal',
  templateUrl: './referee-modal.component.html',
})
export class RefereeModalComponent implements OnInit {
  groupForm: FormGroup;
  isLoading$: Observable<boolean>;
  updateGroupLoading$: Observable<boolean>;
  isAddContactModelOpen$: Observable<boolean>;
  contactError$: Observable<string>;

  addGroupModal: boolean = false;

  updateContactModal: boolean = false;

  user: AuthState;
  selectedContact: any;
  selected_account = localStorage.getItem('selected_account') ? localStorage.getItem('selected_account') : '1';
  ad_admin_id = localStorage.getItem('ad_admin_id');


  contactInputMask = createMask<string>({  
    inputType: 'number',
    mask: '(999)999-9999',
    placeholder: '(xxx)xxx-xxxx',
    positionCaretOnClick: 'select'
  });


  constructor(
    private fb: FormBuilder,
    private toast: ToastService,
    private bll: RefereeContactsBLL,
    private auth: AuthService
  ) {
    this.groupForm = this.fb.group({
      name: ['', [Validators.required]],
      school: ['', [Validators.required]],
      number: ['', [Validators.required]],
      email: ['', [Validators.required]],
      // Optional, comma separated (e.g. "Soccer, Basketball"); the API tidies it.
      sports_officiated: ['', [Validators.maxLength(500)]]
    });
  }

  ngOnInit() {
    this.bll.selectedContact$.subscribe(Contact => {
      if (Contact) {
        this.selectedContact = Contact
        this.name?.setValue(Contact.name ?? '');
        this.school?.setValue(Contact.school ?? '');
        this.number?.setValue(Contact.number ?? '');
        this.email?.setValue(Contact.email ?? '');
        this.sportsOfficiated?.setValue(Contact.sports_officiated ?? '');
      }
    })
    this.bll.isUpdateContactModelOpen$.subscribe(isUpdate => {
      this.updateContactModal = isUpdate;
    });

    this.isAddContactModelOpen$ = this.bll.isAddContactModelOpen$;
    this.contactError$ = this.bll.contactError$;
    this.email?.valueChanges.subscribe(() => this.bll.clearContactError());

    this.auth.auth$.pipe(skipWhile((val) => !val.token), take(1))
      .subscribe((val) => {
        this.user = val;
        if (this.user.id) {
          this.initObservables();
        }
      });
  }

  initObservables() {
    this.isLoading$ = this.bll.isLoading$;
  }

  resetModalState() {
    this.groupForm.reset();
  }

  // Close and reset only once the save succeeds; on failure (e.g. the email
  // isn't a Referee/Assigner account) the modal stays open with the entered
  // values and contactError$ explains why.
  async updateContact() {
    const saved = await this.bll.editContact(
      this.selectedContact.id, this.groupForm.value, this.selected_account == '2' ? this.ad_admin_id: null
    );
    if (!saved) {
      return;
    }
    this.resetModalState()
    this.bll.changeUpdateContactModelOpen(false);
    this.bll.toggleAddContactModel(false);
  }

  async createContact() {
    const saved = await this.bll.createContact(
      this.groupForm.value, this.selected_account == '2' ? this.ad_admin_id: null
    );
    if (!saved) {
      return;
    }
    this.resetModalState()
    this.bll.toggleAddContactModel(false);
  }

  closeModel(isOpen: boolean) {
    this.bll.toggleAddContactModel(isOpen);
    this.bll.clearContactError();
    this.resetModalState()
    this.bll.changeUpdateContactModelOpen(false);
  }

  //#region FORM GETTERS

  get name() {
    return this.groupForm.get('name');
  }

  get school() {
    return this.groupForm.get('school');
  }

  get number() {
    return this.groupForm.get('number');
  }

  get email() {
    return this.groupForm.get('email');
  }

  get sportsOfficiated() {
    return this.groupForm.get('sports_officiated');
  }

  //#endregion FORM GETTERS


}
